import type { DocNode } from '@atlaskit/adf-schema';
import type { ConfluenceUpdatePageCommandProperties } from '@atlassian/rovo-content-bridge-api-commands/commands/confluence-update-page-command';

import type { DocumentUpdateCommandProcessor } from '../stream-processors/update-command-processor';
import type { AIFC_ADF_UPDATE_KEY } from '../types/command-manager';
import { getAgentAttribution } from '../utils/get-agent-attribution';

import type { PassThroughCommandProps } from './command-handler';
import { StreamingCommandHandler } from './streaming-command-handler';

type AdfUpdatePayload = ConfluenceUpdatePageCommandProperties & {
	key: typeof AIFC_ADF_UPDATE_KEY;
};

export class UpdateCommandHandler extends StreamingCommandHandler<ConfluenceUpdatePageCommandProperties> {
	constructor(
		props: PassThroughCommandProps,
		private updateCommandProcessor: DocumentUpdateCommandProcessor,
	) {
		super(props, 'update');
	}

	process(payload: AdfUpdatePayload): void {
		const agentAttribution = getAgentAttribution({
			agentType: payload.agentType,
			agentIdentityAccountId: payload.agentIdentityAccountId,
		});

		this.updateCommandProcessor.streamChunk(
			payload.data.toolCalls,
			payload.isStreamComplete,
			payload.traceId,
			payload.singleInstrumentationId,
			payload.agentName !== undefined
				? {
						agentId: payload.agentId,
						agentName: payload.agentName,
						agentIdentityAccountId: payload.agentIdentityAccountId,
						agentNamedId: payload.agentNamedId,
					}
				: undefined,
			payload.isInlineEdit,
			agentAttribution,
		);
	}

	async finishAction(): Promise<DocNode | undefined> {
		await this.updateCommandProcessor.finish();
		return undefined;
	}

	abort(reason?: 'user_abort' | 'aborted' | 'timeout'): void {
		this.updateCommandProcessor.abort(reason);
	}
}
